import { FormControlLabel, Switch } from '@mui/material'
import { useTranslation } from 'react-i18next'

export type ZeroVolumeFilterToggleProps = Readonly<{
  hideZeroVolumeRows: boolean
  onChange: (next: boolean) => void
}>

export default function ZeroVolumeFilterToggle({ hideZeroVolumeRows, onChange }: ZeroVolumeFilterToggleProps) {
  const { t } = useTranslation()

  return (
    <FormControlLabel
      control={<Switch checked={hideZeroVolumeRows} onChange={(event) => onChange(event.target.checked)} />}
      label={t('bidding.results.hide_zero_volume')}
      sx={{ m: 0 }}
    />
  )
}
